var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"trained-machine-value"},[(_vm.displayPower)?_c('span',[_vm._v("Puissance nominale de la machine entrainée : "),_c('span',[_vm._v(_vm._s(_vm.computePnMe)+" kW")])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d14aa02","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/partials/wizard/TrainedMachinePowerValue.vue
// module id = ADb1
// module chunks = 1